import { render, staticRenderFns } from "./CCalendarSchedule.vue?vue&type=template&id=52004963&scoped=true"
import script from "./CCalendarSchedule.vue?vue&type=script&lang=js"
export * from "./CCalendarSchedule.vue?vue&type=script&lang=js"
import style0 from "./CCalendarSchedule.vue?vue&type=style&index=0&id=52004963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52004963",
  null
  
)

export default component.exports